export default __webpack_public_path__ + "static/media/img_card_2.c1db4b80.svg";